var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 28.18",
    style: {
      enableBackground: "new 0 0 22 28.18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.14,24.98l1.56-5.82c-0.88-1.59-1.35-3.38-1.35-5.19C0.35,8.03,5.18,3.2,11.11,3.2s10.75,4.82,10.75,10.75 S17.04,24.7,11.11,24.7c-1.78,0-3.54-0.45-5.11-1.3L0.14,24.98z M6.29,21.22l0.37,0.22c1.35,0.81,2.89,1.23,4.45,1.23 c4.81,0,8.72-3.91,8.72-8.72s-3.91-8.72-8.72-8.72s-8.72,3.91-8.72,8.72c0,1.59,0.44,3.15,1.28,4.52l0.23,0.37L3.02,22.1 L6.29,21.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.11,15.45c-0.44-0.26-1.02-0.56-1.54-0.35c-0.4,0.16-0.66,0.79-0.91,1.11c-0.13,0.16-0.29,0.19-0.5,0.11 c-1.5-0.6-2.65-1.6-3.48-2.98c-0.14-0.21-0.12-0.38,0.05-0.58c0.25-0.29,0.56-0.63,0.63-1.03s-0.12-0.86-0.28-1.21 c-0.21-0.45-0.44-1.1-0.9-1.35c-0.42-0.24-0.96-0.1-1.33,0.2C6.21,9.88,5.9,10.7,5.91,11.51c0,0.23,0.03,0.46,0.08,0.68 c0.13,0.53,0.38,1.03,0.65,1.51c0.21,0.36,0.44,0.7,0.68,1.04c0.8,1.09,1.8,2.04,2.96,2.75c0.58,0.35,1.2,0.66,1.85,0.88 c0.72,0.24,1.37,0.49,2.15,0.34c0.82-0.16,1.62-0.66,1.95-1.45c0.1-0.23,0.14-0.49,0.09-0.74C16.21,16,15.52,15.7,15.11,15.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.7199fffe78c798b6315486d04c55494e.svg";
export { ForwardRef as ReactComponent };